/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  MenuItem,
  TextField,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import CancellationPopup from '../../../NDC/component/CancellationPopup';
import { CheckboxComponent } from '../../../NDC/component/NDCDetails/CMSDrug/CMSDrugInputContainer';
import { NDCDetailsTextFieldComponent } from '../../../NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import { NDC_TABS_DATA } from '../../../NDC/utility/constants';
import {
  checkSuppRadioDisable,
  getAllClaimReferenceData,
  getAllRebateProgramCode,
  GetAndDispatchClaimByID,
  getClaimClientCode,
  getClaimGroupCode,
  getClaimPlanCode,
  handleClientChangeFilter,
  handleGroupChangeFilter,
  handleRebateProgramChangeFilter,
  handleSelectChangeFilter,
  handleTextFieldChangeFilter,
  setClaimDetailsPopup,
  setClaimErrorPopupMessage,
  setClaimInvoiceSelected,
  setClaimRebateType,
  setClaimSelectBy,
  setClaimSelectedNDCTab,
  setSelectedClaim,
  setSelectedClaimFilter,
  setSelectedClaimIndex,
  setEditedRows,
  setErrorMessage,
  setClaimId,
  setCellFocused,
  setSelectedClaimMode,
  getClaimTableInfo,
  setDisplayClaimSearchScreenObj,
  setSelectedRebateProgram,
  setClaimCategoryCode
} from '../../store/action';
import {
  NDCORClaimRadioData,
  RegularSuppData,
  SelectedClaimModeData,
} from '../../utils/constant';
import * as ConstantMessageData from '../../../../../SharedModules/Errors/constantMessageData';
import { autoFormateDate } from '../../../../../SharedModules/utilities/utilities';
import { validateDateQuarter } from '../../../../../SharedModules/utilities/dateUtilities';
import {
  checkQuarterValidation,
  redirectURLLink,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';

export const RadioGroupComponent = ({
  data = [],
  value = '',
  onChange = () => { },
  disabled = false,
  required = false,
  radioGroupClassName = '',
}) => {
  return (
    <div className="sub-radio no-margin">
      <FormControl>
        <RadioGroup
          row
          value={value}
          onChange={onChange}
          required={required}
          className={`justify-content-between ${radioGroupClassName}`}
        >
          {data.map((item, index) => (
            <FormControlLabel
              value={item.value}
              control={<Radio />}
              label={item.name}
              id={item.value}
              key={index}
              disabled={disabled}
              required={required}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

const SelectClaimSearchComponent = ({
  selectedClaimNDCTab,
  claimSelectByFilter,
  selectBy,
  error,
  setError,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const claimId = useSelector((state) => state.sharedState.claim.claimId);
  const rebateType = useSelector((state) => state.sharedState.claim.rebateType);
  const [selectedDropdown, setSelectedDropdown] = useState("");

  const suppRadioDisable = useSelector(
    (state) => state.sharedState.claim.suppRadioDisable
  );

  const invoiceSelected = useSelector(
    (state) => state.sharedState.claim.invoiceSelected
  );
  const searchScreenReduxObj = useSelector(
    (state) => state.sharedState.claim?.searchScreenReduxObj
  );
  const providerIdTypeDropdown = useSelector(
    (state) => state.sharedState.claim.providerIdTypeDropdown
  );
  const categoryCodeDropdown = useSelector(
    (state) => state.sharedState.claim.categoryCodeDropdown
  );

  const rebateProgramDropdown = useSelector(
    (state) => state.sharedState.claim.rebateProgramDropdown
  );

  const clientDropdown = useSelector(
    (state) => state.sharedState.claim.clientDropdown
  );
  const groupDropdown = useSelector(
    (state) => state.sharedState.claim.groupDropdown
  );
  const planDropdown = useSelector(
    (state) => state.sharedState.claim.planDropdown
  );

  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const claimDetailsPopup = useSelector(
    (state) => state.sharedState.claim.claimDetailsPopup
  );
  const claimCategoryCode = useSelector(
      (state) => state.sharedState.claim.claimCategoryCode
    );

  React.useEffect(() => {
    if (categoryCodeDropdown && categoryCodeDropdown.length > 0) {
      if (!claimCategoryCode || claimCategoryCode === '-1') {
        const defaultVal = categoryCodeDropdown[0].value;
        dispatch(setClaimCategoryCode(defaultVal));
        dispatch(handleSelectChangeFilter(null, 'claimCategoryCd', defaultVal));
      }
    }
  }, [categoryCodeDropdown, claimCategoryCode, dispatch]);

  useEffect(() => {
    dispatch(getAllClaimReferenceData());
    dispatch(getAllRebateProgramCode());
    if (!claimCategoryCode || claimCategoryCode === '-1') {
      dispatch(handleSelectChangeFilter(null, 'claimCategoryCd', 'ALL'));
    }
  }, [dispatch, claimCategoryCode]);
    const [rebateProgram, setRebateProgram] = React.useState();
 const selectedData = useSelector(
      (state) => state.sharedState.claim.selectedRebateProgram
    );
      React.useEffect(() => {
          setRebateProgram(selectedData?.rebateProgram);
        }, [selectedData]);
  
    React.useEffect(() => {
        
     if (!selectedData?.plan) {
        setRebateProgram(
         userDefaults?.rebateProgramCd ? userDefaults?.rebateProgramCd : '-1'
       );
       dispatch(
         setSelectedRebateProgram({
           rebateProgram: userDefaults?.rebateProgramCd
             ? userDefaults?.rebateProgramCd
             : '-1',
         })
       );
     }
   }, [userDefaults]);

  useEffect(() => {
    if (claimSelectByFilter && claimSelectByFilter.client) {
      dispatch(
        getClaimGroupCode({
          clientId: claimSelectByFilter.client,
        })
      );
    }
  }, [claimSelectByFilter && claimSelectByFilter.client]);

  useEffect(() => {
    if (claimSelectByFilter && claimSelectByFilter.group) {
      dispatch(
        getClaimPlanCode({
          clientId: claimSelectByFilter.client,
          groupId: claimSelectByFilter.group,
        })
      );
    }
  }, [claimSelectByFilter && claimSelectByFilter.group]);
  // useEffect(() => {
  //   let isMounted = true;
  //     const savedValue = localStorage.getItem("selectedClaimCategoryCd");
  //     if (savedValue && isMounted) {
  //       setSelectedDropdown(savedValue);}
  //   return () => {
  //     isMounted = false;
  //   };
  // }, []);
  useEffect(() => {
    if (userDefaults?.rebateProgramCd && (!claimSelectByFilter || !claimSelectByFilter.rebateProgramCd)) {
      dispatch(
        setSelectedClaimFilter({
          ...claimSelectByFilter,
          rebateProgramCd: userDefaults.rebateProgramCd,
        })
      );
      dispatch(
        handleRebateProgramChangeFilter(userDefaults.rebateProgramCd)
      );
    }
  }, [userDefaults?.rebateProgramCd]);

  useEffect(() => {
    if (
      claimSelectByFilter &&
      claimSelectByFilter.rebateProgramCd &&
      claimSelectByFilter.rebateProgramCd !== 'ALL'
    ) {
      dispatch(
        getClaimClientCode({
          rebateProgramCd: claimSelectByFilter.rebateProgramCd,
        })
      );
    }

    if (claimSelectByFilter && claimSelectByFilter.rebateProgramCd) {
      dispatch(checkSuppRadioDisable(claimSelectByFilter.rebateProgramCd));
      dispatch(setClaimRebateType('Regular'));
    }
  }, [claimSelectByFilter && claimSelectByFilter.rebateProgramCd]);

  const navigateToSelectedClaimScreen = () => {
    dispatch(setSelectedClaimMode(SelectedClaimModeData[1].value));
    if (selectBy === NDCORClaimRadioData[1].value) {
      dispatch(
        setSelectedClaimFilter({
          ...claimSelectByFilter,
          invoiceSelected: {
            ...claimSelectByFilter.invoiceSelected,
            invoiced: false,
            nonInvoiced: false,
          },
          rebateType,
        })
      );
    }
    redirectURLLink('/selected-claim', 'Selected Claim', history, dispatch);

    dispatch(setSelectedClaimIndex(1));

    history.push({
      pathname: '/selected-claim',
    });
  };
  const objClaimId = {
    claimId: claimId,
    userID: userDefaults?.userId,
    // userLastName: 'TEST',
    functionCode: 'Claim',
    eventInquryKeyVO: [
      {
        keyType: 'Claim ID',
        key: claimId,
      },
    ],
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    if (type === 'processedQtr') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        setError({
          ...error,
          processedQtr: false,
        });
        dispatch(setClaimErrorPopupMessage(null));
        if (checkQuarterValidation(value)) {
          dispatch(
            handleTextFieldChangeFilter(
              {
                target: {
                  value: autoFormateDate(value?.toUpperCase()),
                },
              },
              'processedQtr'
            )
          );
        } else {
          setError({
            ...error,
            processedQtr: true,
          });
          dispatch(
            setClaimErrorPopupMessage(
              ConstantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI
            )
          );
        }
      }
    }
  };
  // if the format is not correct, error message will be displayed
  const handleBlurDate = (event, name) => {
    const dateFromPicker = event?.target?.value?.toUpperCase();
    const regexNumber = /^[0-9/]+$/;

    if (dateFromPicker?.includes('Q') || dateFromPicker?.includes('q')) {
      const dateUpperCase = autoFormateDate(dateFromPicker.toUpperCase());
      const splitYear = dateUpperCase.split('Q');
      const checkQuater = splitYear[0] <= 4;

      if (checkQuater) {
        if (
          (dateFromPicker.length === 6 || dateFromPicker.length === 4) &&
          regexNumber.test(splitYear[1]) &&
          splitYear[1] >= 1991 &&
          splitYear[1] <= 9999
        ) {
          dispatch(
            handleTextFieldChangeFilter(
              {
                target: {
                  value: autoFormateDate(dateFromPicker.toUpperCase()),
                },
              },
              name
            )
          );
          setError({
            ...error,
            paidQtr: false,
          });
          dispatch(setClaimErrorPopupMessage(null));
        } else {
          setError({
            ...error,
            paidQtr: true,
          });
          dispatch(
            setClaimErrorPopupMessage(ConstantMessageData.DATE_QTR_VALIDATION)
          );
        }
      } else {
        setError({
          ...error,
          paidQtr: true,
        });
        dispatch(
          setClaimErrorPopupMessage(ConstantMessageData.DATE_QTR_VALIDATION)
        );
      }
    } else if (
      regexNumber?.test(dateFromPicker) &&
      dateFromPicker?.includes('/')
    ) {
      const dateValue = autoFormateDate(dateFromPicker);
      if (validateDateQuarter(dateValue, name)?.length > 0) {
        setError({
          ...error,
          paidQtr: true,
        });
        dispatch(
          setClaimErrorPopupMessage(ConstantMessageData.DATE_QTR_VALIDATION)
        );
      } else {
        setError({
          ...error,
          paidQtr: false,
        });
        dispatch(setClaimErrorPopupMessage(null));
      }
      dispatch(
        handleTextFieldChangeFilter(
          {
            target: { value: dateValue },
          },
          name
        )
      );
    } else if (dateFromPicker === '') {
      setError({
        ...error,
        paidQtr: true,
      });
      dispatch(
        setClaimErrorPopupMessage(ConstantMessageData.DATE_QTR_VALIDATION)
      );
    } else {
      setError({
        ...error,
        paidQtr: true,
      });
      dispatch(
        setClaimErrorPopupMessage(ConstantMessageData.DATE_QTR_VALIDATION)
      );
    }
  };

  return (
    <div className="panel mb-3">
      <div className="row">
        <div className="col-sm-12">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">Select By</legend>
            <div className="p-0 mt-2 row">
              <div
                className="mui-custom-form col-6 m-0 w-100"
                style={{ flex: 'auto' }}
              >
                <RadioGroupComponent
                  data={NDCORClaimRadioData}
                  value={selectBy}
                  onChange={(_, value) => {
                    dispatch(setClaimSelectBy(value));
                    setError(null);
                    dispatch(setClaimErrorPopupMessage(null));
                  }}
                />
              </div>
              <div className="col-6" />
              {selectBy === NDCORClaimRadioData[0].value && (
                <>
                  <div className="col-4">
                    <NDCDetailsTextFieldComponent
                      required
                      className="ml-0"
                      label="Paid Date/ Qtr"
                      maxLength={10}
                      error={(error && error.paidQtr) || false}
                      value={claimSelectByFilter && claimSelectByFilter.paidQtr}
                      disabled={false}
                      onChange={(e) => {
                        if (/^[0-9/Q]+$/g.test(e.target.value.toUpperCase())) {
                          dispatch(
                            handleTextFieldChangeFilter(
                              {
                                target: { value: e.target.value.toUpperCase() },
                              },
                              'paidQtr'
                            )
                          );
                        } else if (e.target.value === '') {
                          dispatch(handleTextFieldChangeFilter(e, 'paidQtr'));
                        }
                      }}
                      onBlur={(e) => {
                        handleBlurDate(e, 'paidQtr');
                      }}
                    />
                  </div>
                  <div className="col-4">
                    <NDCDetailsTextFieldComponent
                      className="ml-0"
                      label="Processed Qtr"
                      required={false}
                      maxLength={6}
                      value={
                        claimSelectByFilter && claimSelectByFilter.processedQtr
                      }
                      error={(error && error.processedQtr) || false}
                      disabled={false}
                      onChange={(e) => {
                        if (e.target.value) {
                          dispatch(
                            handleTextFieldChangeFilter(
                              {
                                target: { value: e.target.value },
                              },
                              'processedQtr'
                            )
                          );
                        } else if (e.target.value === '') {
                          dispatch(
                            handleTextFieldChangeFilter(e, 'processedQtr')
                          );
                        }
                      }}
                      onBlur={(e) => {
                        if (e.target.value) {
                          dispatch(
                            handleTextFieldChangeFilter(
                              {
                                target: {
                                  value: autoFormateDate(
                                    autoFormateDate(
                                      e.target.value?.toUpperCase()
                                    )
                                  ),
                                },
                              },
                              'processedQtr'
                            )
                          );
                        }
                      }}
                    />
                  </div>
                  <div className="col-4">
                    <div className="mui-custom-form  with-select w-100 ml-0">
                      <TextField
                        data-testid="providerIdTypeCd-display-claim"
                        id="providerIdTypeCd"
                        label="Provider ID Type"
                        fullWidth
                        select
                        required={false}
                        placeholder=""
                        inputProps={{ maxLength: 11, id: 'providerIdTypeCd' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={claimSelectByFilter?.providerIdTypeCd || -1}
                        onChange={(e) => {
                          dispatch(
                            handleSelectChangeFilter(e, 'providerIdTypeCd')
                          );
                        }}
                        className=" "
                        error={
                          (error &&
                            error.providerError &&
                            (!claimSelectByFilter ||
                              !claimSelectByFilter.providerIdTypeCd)) ||
                          false
                        }
                        helperText={
                          (error?.providerError &&
                            (!claimSelectByFilter ||
                              !claimSelectByFilter.providerIdTypeCd)) ||
                          false
                        }
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />

                        {providerIdTypeDropdown?.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.value}>
                              {item.label ? `${item.label}` : `${item.value}`}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </div>
                  </div>
                  <div className="col-4">
                    <NDCDetailsTextFieldComponent
                      label="Provider ID"
                      maxLength={20}
                      required={false}
                      value={
                        claimSelectByFilter && claimSelectByFilter.providerId
                      }
                      error={
                        (error &&
                          error.providerError &&
                          (!claimSelectByFilter ||
                            !claimSelectByFilter.providerId)) ||
                        false
                      }
                      className="ml-0"
                      disabled={false}
                      onChange={(e) => {
                        dispatch(handleTextFieldChangeFilter(e, 'providerId'));
                      }}
                    />
                  </div>
                    <div className="col-4">
                    <NDCDetailsTextFieldComponent
                      label="Rebate Program"
                      required
                      value={
                        claimSelectByFilter?.rebateProgramCd ?
                        claimSelectByFilter?.rebateProgramCd:
                        userDefaults?.rebateProgramCd?userDefaults?.rebateProgramCd:''
                      }
                      className="ml-0 with-select"
                      error={(error && error.rebateProgramError) || false}
                      select
                      selectReset={false}
                      selectData={rebateProgramDropdown}
                      disabled={false}
                      onChange={(e) => {
                        dispatch(
                          handleRebateProgramChangeFilter(e.target.value)
                        );
                      }}
                    />
                  </div>
                  <div className="col-4">
                    <div className="mui-custom-form  with-select w-100 ml-0">
                      <TextField
                        data-testid="client-display-claim"
                        id="client"
                        label="Client"
                        fullWidth
                        select
                        required={false}
                        placeholder=""
                        inputProps={{ maxLength: 11, id: 'client' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={claimSelectByFilter?.client || -1}
                        disabled={
                          !!(
                            !claimSelectByFilter ||
                            !claimSelectByFilter.rebateProgramCd ||
                            claimSelectByFilter.rebateProgramCd === 'ALL'
                          )
                        }
                        onChange={(e) => {
                          dispatch(handleClientChangeFilter(e.target.value));
                        }}
                        className=" "
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />

                        {clientDropdown?.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.value}>
                              {item.label ? `${item.label}` : `${item.value}`}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="mui-custom-form  with-select w-100 ml-0">
                      <TextField
                        data-testid="Group-display-claim"
                        id="group"
                        label="Group"
                        fullWidth
                        select
                        required={false}
                        placeholder=""
                        inputProps={{ maxLength: 11, id: 'group' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={claimSelectByFilter?.group || -1}
                        disabled={
                          !!(
                            !claimSelectByFilter || !claimSelectByFilter.client
                          )
                        }
                        onChange={(e) => {
                          dispatch(handleGroupChangeFilter(e.target.value));
                        }}
                        className=" "
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />

                        {groupDropdown?.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.value}>
                              {item.label ? `${item.label}` : `${item.value}`}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="mui-custom-form  with-select w-100 ml-0">
                      <TextField
                        data-testid="Plan-display-claim"
                        id="plan"
                        label="Plan"
                        fullWidth
                        select
                        required={false}
                        placeholder=""
                        inputProps={{ maxLength: 11, id: 'plan' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={claimSelectByFilter?.plan || -1}
                        disabled={
                          !!(!claimSelectByFilter || !claimSelectByFilter.group)
                        }
                        onChange={(e) => {
                          dispatch(handleSelectChangeFilter(e, 'plan'));
                        }}
                        className=" "
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />

                        {planDropdown?.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.value}>
                              {item.label ? `${item.label}` : `${item.value}`}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </div>
                  </div>
                  <div className="col-4">
                    <NDCDetailsTextFieldComponent
                      label="Claim Category Code"
                      required
                      // value={
                      //   claimSelectByFilter &&
                      //   claimSelectByFilter.claimCategoryCd
                      // }
                      value={claimCategoryCode}
                      className="ml-0 with-select"
                      select
                      selectReset={false}
                      selectData={categoryCodeDropdown}
                      error={(error && error.claimCategoryError) || false}
                      disabled={false}
                      onChange={(e) => {
                        // setSelectedDropdown(e.target.value);
                         dispatch(setClaimCategoryCode(e.target.value))
                        // localStorage.setItem("selectedClaimCategoryCd", e.target.value);
                        dispatch(
                          handleSelectChangeFilter(e, 'claimCategoryCd')
                        );
                      }}
                    />
                  </div>
                </>
              )}
              {selectBy === NDCORClaimRadioData[1].value && (
                <>
                  <div className="col-4">
                    <NDCDetailsTextFieldComponent
                      required
                      maxLength={30}
                      label="Claim ID"
                      value={claimId}
                      className="ml-0 mb-0"
                      disabled={false}
                      onChange={(e) => {
                        dispatch(setClaimId(e.target.value));
                      }}
                    />
                  </div>
                  <div
                    className="col-4 align-items-end d-flex"
                    style={{ paddingTop: '10px' }}
                  >
                    <Button
                      className="btn btn-success btn-view"
                      onClick={() => {
                        dispatch(
                          GetAndDispatchClaimByID(
                            {
                              claimId: claimId,
                              userID: userDefaults?.userId,
                            },
                            () => {
                              navigateToSelectedClaimScreen();
                            },
                            true,
                            true
                          )
                        );
                        dispatch(setEditedRows([]));
                        dispatch(
                          setDisplayClaimSearchScreenObj({
                            ...searchScreenReduxObj,
                            isibwdndc: false,
                            isibwdclaim: false,
                          })
                        );
                      }}
                      title="View Unit Conversion"
                    >
                      <SVGComponent iconName="Icon-view" />
                      View Claim Detail
                    </Button>
                  </div>
                </>
              )}
            </div>
          </fieldset>
        </div>
        {selectBy === NDCORClaimRadioData[0].value && (
          <div className="col-sm-6 mt-3">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">Invoice Status</legend>
              <div className="p-0 mt-2 row">
                <div className="mui-custom-form col-12 m-0 d-flex customCheckbox flex-wrap align-items-center">
                  <div
                    style={{ flex: 1 }}
                    className="d-flex justify-content-around align-items-center"
                  >
                    <div className="text-blue sub-radio no-margin">
                      <CheckboxComponent
                        label="Invoiced"
                        checked={invoiceSelected.invoiced}
                        labelPlacement="end"
                        disabled={false}
                        onChange={(e) => {
                          dispatch(
                            setClaimInvoiceSelected({
                              ...invoiceSelected,
                              invoiced: e.target.checked,
                            })
                          );
                        }}
                      />
                    </div>
                    <div className="text-blue sub-radio no-margin">
                      <CheckboxComponent
                        label="Non-Invoiced"
                        checked={invoiceSelected.nonInvoiced}
                        labelPlacement="end"
                        disabled={false}
                        onChange={(e) => {
                          dispatch(
                            setClaimInvoiceSelected({
                              ...invoiceSelected,
                              nonInvoiced: e.target.checked,
                            })
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <FormControl>
                      <RadioGroup
                        row
                        value={rebateType}
                        onChange={(_, value) => {
                          dispatch(setClaimRebateType(value));
                        }}
                        className="justify-content-between justify-content-around"
                      >
                       {RegularSuppData?.map((item, index) => (
                          <FormControlLabel
                            key={`${item.value}_${index}`}
                            value={item.value}
                            control={<Radio />}
                            label={item.name}
                            id={item.value}
                            disabled={
                              item.value === "Supplemental" &&
                              (
                                claimSelectByFilter?.rebateProgramCd === "ALL" ||
                                claimSelectByFilter?.rebateProgramCd === undefined
                              )
                            }
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        )}
        {selectBy === NDCORClaimRadioData[0].value && (
          <div className="col-sm-6 mt-3">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">Search Type</legend>
              <div className="p-0 mt-2 row">
                <div className="mui-custom-form col-12 m-0">
                  <RadioGroupComponent
                    radioGroupClassName="justify-content-around"
                    data={NDC_TABS_DATA}
                    value={selectedClaimNDCTab}
                    onChange={(_, value) => {
                      dispatch(setClaimSelectedNDCTab(value));
                    }}
                  />
                </div>
              </div>
            </fieldset>
          </div>
        )}
      </div>
      <CancellationPopup
        modalTitle="Select Claim For Display"
        label={`${claimDetailsPopup.total} claims found for these criteria. Continue?`}
        open={claimDetailsPopup.open}
        handleClose={() => {
          dispatch(setClaimDetailsPopup({ open: false, total: 0, data: null }));
        }}
        onConfirmClick={async () => {
          sessionStorage.removeItem('selectedClaimFirstInit');
          dispatch(getClaimTableInfo(true));
          dispatch(setSelectedClaim(claimDetailsPopup.data));
          dispatch(
            setSelectedClaimFilter({
              ...claimSelectByFilter,
              invoiceSelected,
              rebateType,
            })
          );
          dispatch(setCellFocused(-1));
          dispatch(setClaimDetailsPopup({ open: false, total: 0, data: null }));
          navigateToSelectedClaimScreen();
        }}
      />
    </div>
  );
};

export default SelectClaimSearchComponent;
